import { Tags } from "@/enum/tags";
import { apiSlice } from "../http";

export const spedDevolutionApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    uploadSpedDevolutionFiles: builder.mutation<Blob, { body: FormData }>({
      query: ({ body }) => {        
        return {
          url: `/sped/devolution/`,
          method: "POST",
          body,
          responseHandler: (response: Response) => response.blob(),
        };
      },
     
      invalidatesTags: [Tags.SPED_DEVOLUTION],
    }),
    
  }),
  overrideExisting: true,
  
});

export const { useUploadSpedDevolutionFilesMutation } = spedDevolutionApi;
